import React, { useState, useEffect } from "react";
import styled from "styled-components";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setVisible(false);
  };

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };

  if (!visible) return null;

  return (
    <Overlay>
      <Popup>
        <p>
          Ta strona używa plików cookies, aby zapewnić lepszą jakość korzystania z
          serwisu. Kontynuując korzystanie z witryny, wyrażasz zgodę na ich użycie.
        </p>

        <Buttons>
          <Button onClick={acceptCookies}>Akceptuję</Button>
          <LinkButton onClick={toggleDetails}>
            {showDetails ? "Ukryj szczegóły" : "Ustawienia i szczegóły"}
          </LinkButton>
        </Buttons>

        {showDetails && (
          <Details>
            <h4>📋 Polityka Prywatności</h4>
            <p>
              Dane osobowe są przetwarzane przez firmę DATAIN Sp. z o.o. w celu
              świadczenia usług, kontaktu i realizacji zamówień. Masz prawo dostępu,
              poprawiania i usunięcia swoich danych. Nie przekazujemy ich osobom
              trzecim bez zgody, chyba że wymagają tego przepisy prawa.
            </p>
            <a href="/polityka-prywatnosci.pdf" target="_blank" rel="noreferrer">
              Zobacz pełną politykę prywatności
            </a>

            <h4>🍪 Polityka Cookies</h4>
            <p>
              Korzystamy z plików cookies w celu zapamiętywania preferencji użytkownika
              oraz analizowania ruchu na stronie. Ustawienia cookies można zmienić w
              przeglądarce.
            </p>
            <a href="/polityka-cookies.pdf" target="_blank" rel="noreferrer">
              Zobacz pełną politykę cookies
            </a>
          </Details>
        )}
      </Popup>
    </Overlay>
  );
};

export default CookieConsent;

// Styled Components
const Overlay = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.98);
  border-top: 1px solid #ddd;
  z-index: 9999;
  padding: 1rem;
`;

const Popup = styled.div`
  max-width: 1000px;
  margin: auto;
  font-size: 0.95rem;
  color: #333;
`;

const Buttons = styled.div`
  margin-top: 0.5rem;
  display: flex;
  gap: 1rem;
`;

const Button = styled.button`
  background-color: #3bc3cc;
  color: white;
  padding: 0.5rem 1.2rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

const LinkButton = styled.button`
  background: none;
  color: #3bc3cc;
  border: none;
  cursor: pointer;
  text-decoration: underline;
`;

const Details = styled.div`
  margin-top: 1rem;
  background: #f9f9f9;
  padding: 1rem;
  border-radius: 8px;

  h4 {
    margin-top: 0.5rem;
    color: #444;
  }

  p {
    font-size: 0.9rem;
    color: #555;
  }

  a {
    display: inline-block;
    margin-top: 0.3rem;
    color: #007bff;
  }
`;
